'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "MediaCard": "Polaris-MediaCard",
  "portrait": "Polaris-MediaCard--portrait",
  "MediaContainer": "Polaris-MediaCard__MediaContainer",
  "sizeSmall": "Polaris-MediaCard--sizeSmall",
  "InfoContainer": "Polaris-MediaCard__InfoContainer",
  "ActionContainer": "Polaris-MediaCard__ActionContainer"
};

exports.default = styles;
